import backendUrl from "./backendUrl";

// Review API endpoints
export const reviewApi = {
  createReview: {
    url: `${backendUrl}/api/create-review`,
    method: "POST",
  },
  getProductReviews: {
    url: `${backendUrl}/api/product-reviews`,
    method: "GET",
  },
  updateReview: {
    url: `${backendUrl}/api/update-review`,
    method: "PUT",
  },
  deleteReview: {
    url: `${backendUrl}/api/delete-review`,
    method: "DELETE",
  },
  markHelpful: {
    url: `${backendUrl}/api/mark-helpful`,
    method: "POST",
  },
  getAllReviews: {
    url: `${backendUrl}/api/all-reviews`,
    method: "GET",
  },
  moderateReview: {
    url: `${backendUrl}/api/moderate-review`,
    method: "POST",
  },
  homeReviews: {
    url: `${backendUrl}/api/home-reviews`,
    method: "GET",
  },
};
